import { ServerResponse } from 'http'
import { normaliseUrl } from './normaliseUrl'

export const handleNormaliseRedirects = (
  customAsPath: string,
  res: ServerResponse | undefined,
) => {
  if (res && customAsPath) {
    const normalisedUrl = normaliseUrl(customAsPath)
    if (customAsPath !== normalisedUrl) {
      const maxAge = 24 * 60 * 60 * 90 // 90 days
      res.statusCode = 301
      res.setHeader('Location', normalisedUrl)
      res.setHeader('Cache-Control', `public, max-age=${maxAge}`)
      res.end()

      return {
        pageProps: {
          statusCode: 301,
          location: normalisedUrl,
        },
      } as const
    }
  }

  return null
}
